<template>
  <div class="my-8 py-2 px-6" style="background-color: #716263;">
    <div class="text-h5 my-4 text-center font-weight-bold">¿A qué esperas para activar la versión completa?</div>
    <h-purchase-btn />
  </div>
</template>

<script>
  // import I18n from '@/Mixins/I18n'
  import HPurchaseBtn from '../PurchaseBtn'

  export default {
    mixins: [
      // I18n,
    ],

    components: {
      HPurchaseBtn,
    },
  }
</script>
